import { SVGProps } from "react"
const LineMobileVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={2}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 1h28"
    />
  </svg>
)
export default LineMobileVector
